export default __webpack_public_path__ + "static/media/may-2018.a60ad5a1.csv";